export default __webpack_public_path__ + "b61fdcb3db4524f5ec5c4d6b810a53a2.png";